import {ALL_BUILDING_CONFIGS} from "../configs/tokens";
import {isPlayerFaction} from "./factions/isPlayerFaction";
import {FACTIONS} from "../constants/factions";
import {SPECIAL_BUILDING_TOKENS, TOKENS} from "../constants/tokens";
import {FACTION_VENTORY_BUILDING_ROAD_COINS_DISCOUNT} from "../configs/factions/ventory";
import {isPlayerPolicy} from "./factions/isPlayerPolicy";
import {POLICIES} from "../constants/policies";
import {POLICY_DESPOTISM_BUILDING_DISCOUNT_MILITARY_CAMP} from "../configs/policy/despotism";
import {
  POLICY_INDUSTRIALISM_BUILDING_DISCOUNT_ARSENAL,
  POLICY_INDUSTRIALISM_BUILDING_DISCOUNT_FORTRESS,
  POLICY_INDUSTRIALISM_BUILDING_DISCOUNT_MILITARY_CAMP,
  POLICY_INDUSTRIALISM_BUILDING_DISCOUNT_PALACE,
  POLICY_INDUSTRIALISM_BUILDING_DISCOUNT_WAREHOUSE
} from "../configs/policy/industrialism";
import {POLICY_PATRIOTISM_BUILDING_DISCOUNT_ARSENAL} from "../configs/policy/patriotism";
import {POLICY_FORTIFICATIONISM_BUILDING_DISCOUNT_FORTRESS} from "../configs/policy/fortificationism";
import {POLICY_THEOCRACY_BUILDING_DISCOUNT_TEMPLE} from "../configs/policy/theocracy";
import {POLICY_TOTALITARIANISM_BUILDING_DISCOUNT_ARSENAL_AND_MILITARY_CAMP} from "../configs/policy/totalitarianism";
import {
  POLICY_AGRARIANISM_BUILDING_DISCOUNT_WAREHOUSE,
  POLICY_AGRARIANISM_BUILDING_PRICE_FARM
} from "../configs/policy/agrarianism";
import {CONSTRUCTION_ACTION_TYPES} from "../constants/construction";
import {POLICY_ISOLATIONISM_SPECIAL_BUILDING_DISCOUNT} from "../configs/policy/isolationism";
import {FACTION_ELEMENTALS_BUILDING_CENTRAL_QUARTER_DISCOUNT} from "../configs/factions/elementals";
import {checkIfCentralQuarter} from "./buildings/checkIfCentralQuarter";

export const getBuildingPrice = (buildingId, player, pendingBuildings) => {
  const building = ALL_BUILDING_CONFIGS.find(b => b.id === buildingId);

  let isFreeAction = false;

  let price = building && building.priceCoins !== undefined ? building.priceCoins : 0;
  const originalPrice = price;

  // FACTIONS ---------------------------------------

  if (isPlayerFaction(player, FACTIONS.VENTORY)) {
    if (buildingId === TOKENS.ROAD) {
      price -= FACTION_VENTORY_BUILDING_ROAD_COINS_DISCOUNT;
    }
  }

  if (isPlayerFaction(player, FACTIONS.ELEMENTALS)) {
    if (checkIfCentralQuarter(buildingId)) {
      price -= FACTION_ELEMENTALS_BUILDING_CENTRAL_QUARTER_DISCOUNT;
    }
  }

  // POLICIES ---------------------------------------

  if (isPlayerPolicy(player, POLICIES.DESPOTISM)) {
    if (buildingId === SPECIAL_BUILDING_TOKENS.MILITARY_CAMP) {
      price -= POLICY_DESPOTISM_BUILDING_DISCOUNT_MILITARY_CAMP;
    }
  }

  if (isPlayerPolicy(player, POLICIES.INDUSTRIALISM)) {
    switch (buildingId) {
      case SPECIAL_BUILDING_TOKENS.PALACE:
        price -= POLICY_INDUSTRIALISM_BUILDING_DISCOUNT_PALACE;
        break;
      case SPECIAL_BUILDING_TOKENS.WAREHOUSE:
        price -= POLICY_INDUSTRIALISM_BUILDING_DISCOUNT_WAREHOUSE;
        break;
      case SPECIAL_BUILDING_TOKENS.MILITARY_CAMP:
        price -= POLICY_INDUSTRIALISM_BUILDING_DISCOUNT_MILITARY_CAMP;
        break;
      case SPECIAL_BUILDING_TOKENS.ARSENAL:
        price -= POLICY_INDUSTRIALISM_BUILDING_DISCOUNT_ARSENAL;
        break;
      case SPECIAL_BUILDING_TOKENS.FORTRESS:
        price -= POLICY_INDUSTRIALISM_BUILDING_DISCOUNT_FORTRESS;
        break;
      default:
    }
  }

  if (isPlayerPolicy(player, POLICIES.PATRIOTISM)) {
    if (buildingId === SPECIAL_BUILDING_TOKENS.ARSENAL) {
      price -= POLICY_PATRIOTISM_BUILDING_DISCOUNT_ARSENAL;
    }
  }

  if (isPlayerPolicy(player, POLICIES.FORTIFICATIONISM)) {
    if (buildingId === SPECIAL_BUILDING_TOKENS.FORTRESS) {
      price -= POLICY_FORTIFICATIONISM_BUILDING_DISCOUNT_FORTRESS;
    }
  }

  if (isPlayerPolicy(player, POLICIES.THEOCRACY)) {
    if (buildingId === SPECIAL_BUILDING_TOKENS.TEMPLE) {
      price -= POLICY_THEOCRACY_BUILDING_DISCOUNT_TEMPLE;
    }
  }

  if (isPlayerPolicy(player, POLICIES.TOTALITARIANISM)) {
    if (buildingId === SPECIAL_BUILDING_TOKENS.ARSENAL
      || buildingId === SPECIAL_BUILDING_TOKENS.MILITARY_CAMP
    ) {
      price -= POLICY_TOTALITARIANISM_BUILDING_DISCOUNT_ARSENAL_AND_MILITARY_CAMP;
    }
  }

  if (isPlayerPolicy(player, POLICIES.AGRARIANISM)) {
    if (buildingId === SPECIAL_BUILDING_TOKENS.WAREHOUSE) {
      price -= POLICY_AGRARIANISM_BUILDING_DISCOUNT_WAREHOUSE;
    } else if (buildingId === TOKENS.FARM) {
      const isFarmAlreadyBuilt = pendingBuildings.some(action => {
        return action.token === TOKENS.FARM && action.type === CONSTRUCTION_ACTION_TYPES.CONSTRUCTION
      });

      if (!isFarmAlreadyBuilt) {
        price = POLICY_AGRARIANISM_BUILDING_PRICE_FARM;
        isFreeAction = true;
      }
    }
  }


  if (isPlayerPolicy(player, POLICIES.ISOLATIONISM)) {
    if (Object.values(SPECIAL_BUILDING_TOKENS).includes(buildingId)) {
      price -= POLICY_ISOLATIONISM_SPECIAL_BUILDING_DISCOUNT;
    }
  }
  //  ---------------------------------------

  const isDiscount = price < originalPrice;

  return {priceCoins: Math.max(0, price), isDiscount, isFreeAction};
};